import { buildFaqAnswerUrl } from '@karakuri-web/common/utils'

export function buildAnswerHref(id: string, pathPrefix: string | null | undefined) {
  return buildFaqAnswerUrl(null, pathPrefix, id)
}

export function buildAnswerPath(id: string) {
  return `/answer/${id}/`
}
